// Web mirror of the purchasable cosmetics catalog.
//
// SOURCES OF TRUTH: names come from ios/PredictSix/Models/CustomizationCatalog.swift;
// prices MUST match functions/src/cosmeticsCatalog.ts PURCHASABLE_CATALOG (the
// server validates the price on `purchaseCosmeticItem`).
//
// LOCKSTEP RULE (CLAUDE.md): when an item is added/repriced in the Swift / TS
// catalogs, update this file in the same commit. This is the THIRD copy of the
// catalog — keep ids + prices identical or web purchases will reject server-side.
//
// Scope (web v1): avatars + taglines + themes. Frames + banners are added to
// this mirror as those customization tabs ship.

// ── Avatars (41: 38 Common @180 + 3 Epic @480) ──────────────────────────────
// Art is exported from the iOS imagesets to app-web/public/avatars/<id>-{light,dark}.png.
export const AVATARS = [
  // Animal Club (18)
  { id: 'avatar-bull', name: 'The Bull', price: 180 },
  { id: 'avatar-bear', name: 'The Bear', price: 180 },
  { id: 'avatar-fox', name: 'The Fox', price: 180 },
  { id: 'avatar-owl', name: 'The Owl', price: 180 },
  { id: 'avatar-octopus', name: 'Paul the Octopus', price: 180 },
  { id: 'avatar-goat', name: 'The GOAT', price: 180 },
  { id: 'avatar-shark', name: 'The Shark', price: 180 },
  { id: 'avatar-wolf', name: 'The Wolf', price: 180 },
  { id: 'avatar-eagle', name: 'The Eagle', price: 180 },
  { id: 'avatar-cat', name: 'The Black Cat', price: 180 },
  { id: 'avatar-rabbit', name: 'The Rabbit', price: 180 },
  { id: 'avatar-lion', name: 'The Lion', price: 180 },
  { id: 'avatar-penguin', name: 'The Penguin', price: 180 },
  { id: 'avatar-raccoon', name: 'The Raccoon', price: 180 },
  { id: 'avatar-hawk', name: 'The Hawk', price: 180 },
  { id: 'avatar-tortoise', name: 'The Tortoise', price: 180 },
  { id: 'avatar-steelhead', name: 'The Steelhead', price: 180 },
  { id: 'avatar-dragon', name: 'The Dragon', price: 180 },
  // Animal Club, feminine cast (8)
  { id: 'avatar-vixen', name: 'The Vixen', price: 180 },
  { id: 'avatar-lioness', name: 'The Lioness', price: 180 },
  { id: 'avatar-leopard', name: 'The Snow Leopard', price: 180 },
  { id: 'avatar-doe', name: 'The Doe', price: 180 },
  { id: 'avatar-swan', name: 'The Swan', price: 180 },
  { id: 'avatar-flamingo', name: 'The Flamingo', price: 180 },
  { id: 'avatar-hummingbird', name: 'The Hummingbird', price: 180 },
  { id: 'avatar-queenbee', name: 'The Queen Bee', price: 180 },
  // The Regulars (12)
  { id: 'avatar-oracle', name: 'The Oracle', price: 180 },
  { id: 'avatar-seer', name: 'The Seer', price: 180 },
  { id: 'avatar-professor', name: 'The Professor', price: 180 },
  { id: 'avatar-scholar', name: 'The Scholar', price: 180 },
  { id: 'avatar-detective', name: 'The Detective', price: 180 },
  { id: 'avatar-sleuth', name: 'The Sleuth', price: 180 },
  { id: 'avatar-gambler', name: 'The Gambler', price: 180 },
  { id: 'avatar-highroller', name: 'The High Roller', price: 180 },
  { id: 'avatar-rookie', name: 'The Rookie', price: 180 },
  { id: 'avatar-prodigy', name: 'The Prodigy', price: 180 },
  { id: 'avatar-analyst', name: 'The Analyst', price: 180 },
  { id: 'avatar-strategist', name: 'The Strategist', price: 180 },
  // Epic (3) @ 480
  { id: 'avatar-epic-star-fox', name: 'Star Ace', price: 480 },
  { id: 'avatar-epic-golden-octopus', name: 'Golden Octopus', price: 480 },
  { id: 'avatar-epic-crystal-cat', name: 'Crystal-Ball Cat', price: 480 },
];

// ── Taglines (36 @180) ──────────────────────────────────────────────────────
export const TAGLINES = [
  { id: 'tag-01', text: 'The Contrarian', price: 180 },
  { id: 'tag-02', text: 'Reads the Room', price: 180 },
  { id: 'tag-03', text: 'Chaos Agent', price: 180 },
  { id: 'tag-04', text: 'Vibes Only', price: 180 },
  { id: 'tag-05', text: "Don't Overthink It", price: 180 },
  { id: 'tag-06', text: 'Trust The Process', price: 180 },
  { id: 'tag-07', text: 'Crowd? Wrong.', price: 180 },
  { id: 'tag-08', text: 'Pattern Recognition', price: 180 },
  { id: 'tag-09', text: 'Six-Sense', price: 180 },
  { id: 'tag-10', text: 'The Oracle', price: 180 },
  { id: 'tag-11', text: 'Predictoor', price: 180 },
  { id: 'tag-12', text: 'The Forecaster', price: 180 },
  { id: 'tag-13', text: 'Quiet Confidence', price: 180 },
  { id: 'tag-14', text: 'Against the Grain', price: 180 },
  { id: 'tag-15', text: 'Calculated Risk', price: 180 },
  { id: 'tag-16', text: 'Usually Right', price: 180 },
  { id: 'tag-17', text: 'Eventually Correct', price: 180 },
  { id: 'tag-18', text: 'Gut Over Math', price: 180 },
  { id: 'tag-19', text: 'Coin Flip Energy', price: 180 },
  { id: 'tag-20', text: 'Signal Over Noise', price: 180 },
  { id: 'tag-21', text: 'Long Game', price: 180 },
  { id: 'tag-22', text: 'Herd Immunity', price: 180 },
  { id: 'tag-23', text: 'Mostly Right', price: 180 },
  { id: 'tag-24', text: 'The Crystal Ball', price: 180 },
  { id: 'tag-25', text: 'In the Numbers', price: 180 },
  { id: 'tag-26', text: 'Cool Under Pressure', price: 180 },
  { id: 'tag-27', text: 'Sharp Elbows', price: 180 },
  { id: 'tag-28', text: 'Feeling Lucky', price: 180 },
  { id: 'tag-29', text: 'Reading Tea Leaves', price: 180 },
  { id: 'tag-30', text: 'Data Speaks', price: 180 },
  { id: 'tag-31', text: 'Black Swan Hunter', price: 180 },
  { id: 'tag-32', text: 'Known Unknowns', price: 180 },
  { id: 'tag-33', text: 'Pure Instinct', price: 180 },
  { id: 'tag-34', text: 'Right Tail', price: 180 },
  { id: 'tag-35', text: 'Wrong, but Early', price: 180 },
  { id: 'tag-36', text: 'Beats the Average', price: 180 },
];

// ── Sheet themes (5 @300; Gold is the free default, not listed) ──────────────
// Light/dark accent hexes mirror iOS MemberSheetTheme.accentColor(for:) EXACTLY
// (deeper in light mode for contrast on cream, brighter in dark on charcoal).
// On equip we set the web --accent CSS var to the hex matching the OS scheme.
export const THEMES = [
  { id: 'theme-crimson', name: 'Crimson', price: 300, accentLight: '#C0392B', accentDark: '#E76B5B' },
  { id: 'theme-sapphire', name: 'Sapphire', price: 300, accentLight: '#2E6FB0', accentDark: '#5D9BE0' },
  { id: 'theme-amber', name: 'Amber', price: 300, accentLight: '#CF6A1A', accentDark: '#F2913E' },
  { id: 'theme-amethyst', name: 'Amethyst', price: 300, accentLight: '#8E5BA6', accentDark: '#B886D6' },
  { id: 'theme-emerald', name: 'Emerald', price: 300, accentLight: '#2E8B57', accentDark: '#4FC487' },
];

// ── Frames (34 purchasable; awarded frames are earned, not shopped) ──────────
// Rendered by AvatarFrame.jsx (web port of the iOS FrameStyle engine — no art
// files). ids + prices mirror functions/src/cosmeticsCatalog.ts PURCHASABLE_CATALOG
// + CustomizationCatalog.swift buildPurchasableFrames EXACTLY (lockstep). The
// gold variant of legacy styles keeps its original id; new colors/styles use the
// frame-<style>-<color> matrix ids. Ordered for the shop (static → animated).
export const FRAMES = [
  // Hairline
  { id: 'frame-static-gold-thin', name: 'Gold Hairline', price: 0, rankGrant: 'REGULAR' },
  { id: 'frame-hairline-crimson', name: 'Crimson Hairline', price: 180 },
  { id: 'frame-hairline-sapphire', name: 'Sapphire Hairline', price: 180 },
  // Bold
  { id: 'frame-static-gold-thick', name: 'Gold Bold', price: 240 },
  { id: 'frame-bold-crimson', name: 'Crimson Bold', price: 240 },
  { id: 'frame-bold-sapphire', name: 'Sapphire Bold', price: 240 },
  // Double Ring
  { id: 'frame-double-gold', name: 'Gold Double Ring', price: 240 },
  { id: 'frame-double-crimson', name: 'Crimson Double Ring', price: 240 },
  { id: 'frame-double-sapphire', name: 'Sapphire Double Ring', price: 240 },
  // Dashed
  { id: 'frame-dashed-gold', name: 'Gold Dashed', price: 200 },
  { id: 'frame-dashed-crimson', name: 'Crimson Dashed', price: 200 },
  { id: 'frame-dashed-sapphire', name: 'Sapphire Dashed', price: 200 },
  // Gem Studs
  { id: 'frame-gem-gold', name: 'Gold Gem Studs', price: 280 },
  { id: 'frame-gem-crimson', name: 'Crimson Gem Studs', price: 280 },
  { id: 'frame-gem-sapphire', name: 'Sapphire Gem Studs', price: 280 },
  // Brushed Metal
  { id: 'frame-metal-gold', name: 'Gold Brushed Metal', price: 300 },
  { id: 'frame-metal-crimson', name: 'Crimson Brushed Metal', price: 300 },
  { id: 'frame-metal-sapphire', name: 'Sapphire Brushed Metal', price: 300 },
  // Category emblems (legacy ids)
  { id: 'frame-static-markets', name: 'Markets', price: 180 },
  { id: 'frame-static-politics', name: 'Politics', price: 180 },
  { id: 'frame-static-sports', name: 'Sports', price: 180 },
  { id: 'frame-static-culture', name: 'Culture', price: 180 },
  { id: 'frame-static-technology', name: 'Discovery', price: 180 },
  { id: 'frame-static-world', name: 'World', price: 180 },
  // Pulse (animated)
  { id: 'frame-anim-pulse', name: 'Gold Pulse', price: 0, rankGrant: 'RIVAL' },
  { id: 'frame-pulse-crimson', name: 'Crimson Pulse', price: 360 },
  { id: 'frame-pulse-sapphire', name: 'Sapphire Pulse', price: 360 },
  // Orbit (animated)
  { id: 'frame-anim-rotation', name: 'Gold Orbit', price: 0, rankGrant: 'LEGEND' },
  { id: 'frame-orbit-crimson', name: 'Crimson Orbit', price: 360 },
  { id: 'frame-orbit-sapphire', name: 'Sapphire Orbit', price: 360 },
  // Sparkle (animated)
  { id: 'frame-anim-sparkle', name: 'Gold Sparkle', price: 0, rankGrant: 'CAPTAIN' },
  { id: 'frame-sparkle-crimson', name: 'Crimson Sparkle', price: 360 },
  { id: 'frame-sparkle-sapphire', name: 'Sapphire Sparkle', price: 360 },
  // Aurora (animated, premium)
  { id: 'frame-anim-aurora', name: 'Aurora', price: 0, rankGrant: 'ORACLE' },
];

// ── Banners (21 live; the 6 retired ids still render for owners but aren't sold
//    on web). Art exported from iOS Banners imagesets → public/banners/<id>.png
//    (3:1, single mode-agnostic image). ids + prices + names mirror
//    CustomizationCatalog.banners (lockstep). ──────────────────────────────────
export const BANNERS = [
  { id: 'banner-aurora-gold', name: 'Gold', price: 0, rankGrant: 'REGULAR' },
  { id: 'banner-aurora-crimson', name: 'Crimson', price: 250 },
  { id: 'banner-aurora-sapphire', name: 'Sapphire', price: 250 },
  { id: 'banner-aurora-emerald', name: 'Emerald', price: 250 },
  { id: 'banner-aurora-amethyst', name: 'Amethyst', price: 250 },
  { id: 'banner-aurora-amber', name: 'Amber', price: 250 },
  { id: 'banner-cat-markets', name: 'Markets', price: 300 },
  { id: 'banner-cat-politics', name: 'Politics', price: 300 },
  { id: 'banner-cat-sports', name: 'Sports', price: 300 },
  { id: 'banner-cat-culture', name: 'Culture', price: 300 },
  { id: 'banner-cat-technology', name: 'Discovery', price: 300 },
  { id: 'banner-cat-world', name: 'World', price: 300 },
  { id: 'banner-champion', name: 'Champion', price: 0, rankGrant: 'CAPTAIN' },
  { id: 'banner-streak', name: 'Streak', price: 350 },
  { id: 'banner-basketball', name: 'Basketball', price: 300 },
  { id: 'banner-poker', name: 'Poker', price: 0, rankGrant: 'RIVAL' },
  { id: 'banner-ai', name: 'A.I.', price: 300 },
  { id: 'banner-baseball', name: 'Baseball', price: 300 },
  { id: 'banner-football', name: 'Football', price: 300 },
  { id: 'banner-soccer', name: 'Soccer', price: 300 },
  { id: 'banner-logo', name: 'Predict Six', price: 0, rankGrant: 'LEGEND' },
  // ORACLE's banner was missing from web entirely (2026-08-05), so an
  // Oracle who earned it on iOS had no tile to equip it from here. The art
  // was already sitting in public/banners/banner-oracle.png.
  { id: 'banner-oracle', name: 'Oracle', price: 0, rankGrant: 'ORACLE' },
];

const AVATAR_IDS = new Set(AVATARS.map((a) => a.id));

/** Web art path for an avatar id + theme ('light' | 'dark'). */
export function avatarArt(id, theme = 'light') {
  return `/avatars/${id}-${theme}.png`;
}

/** True if `id` is a known web-exported avatar (has art on /public/avatars). */
export function isKnownAvatar(id) {
  return typeof id === 'string' && AVATAR_IDS.has(id);
}

/** Display text for an equipped tagline id (or null). */
export function taglineText(id) {
  return TAGLINES.find((t) => t.id === id)?.text ?? null;
}

/** Accent hex for an equipped sheetTheme id, picked for the OS scheme (or null
 *  = gold default). Pass dark=true to get the brighter dark-mode variant. */
export function themeAccent(id, dark = false) {
  const t = THEMES.find((t) => t.id === id);
  if (!t) return null;
  return dark ? t.accentDark : t.accentLight;
}

/** Web art path for a banner id (includes retired ids, which still have art
 *  exported for owners even though they aren't in the BANNERS browse list). */
export function bannerArt(id) {
  return `/banners/${id}.png`;
}
